<template>
  <div></div>
</template>

<script>
export default {
name: "OrdersBottomLeft"
}
</script>

<style scoped>

</style>